/* tslint:disable */
/* eslint-disable */
export enum ExcelDocumentRowStateEnum {
  Ok = 'Ok',
  Warning = 'Warning',
  Error = 'Error',
  Empty = 'Empty'
}
